var _style, _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 71 55",
    style: {
      enableBackground: "new 0 0 71 55"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000173879334928704368360000002154813283307967374_);}\n\t.st1{fill=\"#6C6C6C\"}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 71,
    height: 55
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150793528565603901110000010367501223395944586_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000150793528565603901110000010367501223395944586_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.1,4.9c-4.5-2.1-9.4-3.6-14.5-4.5c-0.1,0-0.2,0-0.2,0.1c-0.6,1.1-1.3,2.6-1.8,3.7 c-5.5-0.8-10.9-0.8-16.2,0c-0.5-1.2-1.2-2.6-1.8-3.7c0-0.1-0.1-0.1-0.2-0.1c-5.1,0.9-9.9,2.4-14.5,4.5c0,0-0.1,0-0.1,0.1 C1.6,18.7-0.9,32.1,0.3,45.4c0,0.1,0,0.1,0.1,0.2c6.1,4.5,12,7.2,17.7,9c0.1,0,0.2,0,0.2-0.1c1.4-1.9,2.6-3.8,3.6-5.9 c0.1-0.1,0-0.3-0.1-0.3c-1.9-0.7-3.8-1.6-5.5-2.6c-0.1-0.1-0.2-0.3,0-0.4c0.4-0.3,0.7-0.6,1.1-0.9c0.1-0.1,0.2-0.1,0.2,0 c11.6,5.3,24.2,5.3,35.7,0c0.1,0,0.2,0,0.2,0c0.4,0.3,0.7,0.6,1.1,0.9c0.1,0.1,0.1,0.3,0,0.4c-1.8,1-3.6,1.9-5.5,2.6 c-0.1,0-0.2,0.2-0.1,0.3c1.1,2.1,2.3,4,3.6,5.9c0.1,0.1,0.2,0.1,0.2,0.1c5.8-1.8,11.7-4.5,17.8-9c0.1,0,0.1-0.1,0.1-0.2 C72.2,30.1,68.2,16.8,60.1,4.9C60.2,4.9,60.1,4.9,60.1,4.9z M23.7,37.3c-3.5,0-6.4-3.2-6.4-7.2s2.8-7.2,6.4-7.2 c3.6,0,6.4,3.2,6.4,7.2C30.1,34.1,27.3,37.3,23.7,37.3z M47.3,37.3c-3.5,0-6.4-3.2-6.4-7.2s2.8-7.2,6.4-7.2c3.6,0,6.4,3.2,6.4,7.2 C53.7,34.1,50.9,37.3,47.3,37.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.eedf9642ac7892e10e762aa84149e142.svg";
export { ForwardRef as ReactComponent };